import { useMemo } from "react";

import { markdownToSafeHtml } from "@/lib/markdown";

interface AiNoteProps {
  markdown: string;
  /** Takip cipleri — kullanicinin AI'ya sorabilecegi hazir devam sorulari. */
  followUps?: string[];
  onFollowUp?: (question: string) => void;
}

/** AI notu — markdown → guvenli HTML (bkz. lib/markdown.ts) + takip cipleri. */
export function AiNote({ markdown, followUps = [], onFollowUp }: AiNoteProps) {
  const html = useMemo(() => markdownToSafeHtml(markdown), [markdown]);

  return (
    <div className="space-y-3">
      <div
        className="text-sm leading-relaxed text-ink [&_li]:mt-1 [&_p+p]:mt-2 [&_ul]:list-disc [&_ul]:pl-5"
        // html, markdownToSafeHtml tarafindan tamamen escape edilip yalniz bilinen guvenli etiketlere donusturulur.
        dangerouslySetInnerHTML={{ __html: html }}
      />
      {followUps.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {followUps.map((question) => (
            <button
              key={question}
              type="button"
              onClick={() => onFollowUp?.(question)}
              className="min-h-[36px] rounded-full border border-line bg-bg px-3 text-xs font-medium text-brand-primary hover:bg-blue-pale"
            >
              {question}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
